// Auto-generated TypeScript enum with enhanced data
// Generated from: vortex\ServicesV2\Orders\DataProviders\OrderField
// Generated on: <normalized>

export enum OrderField {
  DB_TABLE = 'orders',
  DB_IDENTIFIER = 'orderGUID',
  PRODUCT_GUID = 'productGUID',
  ALIAS_GUID = 'aliasGUID',
  STATUS = 'status',
  PAYMENT_LIFECYCLE_REVISION = 'paymentLifecycleRevision',
  REVENUE_STREAM_GUID = 'revenueStreamGUID',
  NET = 'net',
  TAX = 'tax',
  SERVICE_TOTALS = 'serviceTotals',
  CONTACT_DATA = 'contactData',
  JOB_DATA = 'jobData',
  DELIVERY_DATA = 'deliveryData',
  SELECTED_SELECTION_ITEMS = 'selectedSelectionItems',
  BOOLEAN_SETTINGS = 'booleanSettings',
  CONTRACT_SETTINGS = 'contractSettings',
  RULES_APPLIED = 'rulesApplied',
}

export const OrderFieldGetEncryptionFields = [] as const;

export const OrderFieldCases = ["orders", "orderGUID", "productGUID", "aliasGUID", "status", "paymentLifecycleRevision", "revenueStreamGUID", "net", "tax", "serviceTotals", "contactData", "jobData", "deliveryData", "selectedSelectionItems", "booleanSettings", "contractSettings", "rulesApplied"] as const;
